import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.list('type', 'Type', TYPE_OPTIONS)
      .multi(true),
    filter
      .options.list('rules', 'With Rules', WITH_RULES_OPTIONS)
      .getValue(value => JSON.stringify(value))
      .setValue(value => JSON.parse(value)),
    filter.boolean('active', 'Active'),
  ], [])
}

const WITH_RULES_OPTIONS = [
  { label: 'True', value: '{"$not":null}' },
  { label: 'False', value: '{"$eq":null}' },
]

const TYPE_OPTIONS = [
  { label: "HTML", value: "html" },
  { label: "HTTP Get", value: "http_get" },
  { label: "HTTP Post", value: "http_post" },
  { label: 'Twyne Offer', value: 'twyne_offer' },
]
